
/*
 * User related functions
 *
 */
const userMixin = {

  methods: {
    isStaff(user) {
      return user.role == 'staff'
    },

    userName(user) {
      if (!user) { return '' }

      if (user.name) {
        return user.name;
      } else if (user.municipality) {
        return user.municipality.name
      } else {
        return user.user_id
      }
    },

  }

}

export {
  userMixin
}

  